export const IncomeTableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: 'CI/RUC',
                    type: 'custom-html',
                    key: 'accreditation_application',
                    modifier: (value) => {
                        if (value.organization) {
                            return value.organization.taxid;
                        } else {
                            return 'N/A';
                        }
                    }
                },
                {
                    title: 'OEC',
                    type: 'custom-html',
                    key: 'accreditation_application',
                    modifier: (value) => {
                        if (value.organization) {
                            return value.organization.business_name;
                        } else {
                            return 'N/A';
                        }
                    }
                },
                {
                    title: 'Comprobante',
                    type: 'text',
                    key: 'number',
                },
                // {
                //     title: 'Banco',
                //     type: 'custom-html',
                //     key: 'bank',
                //     modifier: (value) => {
                //         if(value){
                //             return value.name;
                //         }else{
                //             return 'N/A';
                //         }
                //     }
                // },
                // {
                //     title: 'Transacción',
                //     type: 'custom-html',
                //     key: 'transactiontype',
                //     modifier: (value) => {
                //         if(value){
                //             return value.name;
                //         }else{
                //             return 'N/A';
                //         }
                //     }
                // },
                {
                    title: 'Monto',
                    type: 'custom-html',
                    key: 'amount',
                    modifier: (value) => {
                        if (value) {
                            return value.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
                        }
                    }
                },
                {
                    title: 'Fecha Pago',
                    type: 'custom-html',
                    key: 'date',
                    modifier: (value) => {
                        if (value) {
                            return moment(value).format("YYYY-MM-DD");
                        }
                    }
                },
                {
                    title: 'Tipo',
                    type: 'custom-html',
                    key: 'type',
                    modifier: (value) => {
                        let type = 'OTRO';
                        if (value === 'S') {
                            type = 'SOLICITUD';
                        } else if (value === 'P') {
                            type = 'PROFORMA';
                        }
                        return type;
                    }
                },
                {
                    title: 'Pago de',
                    type: 'custom-html',
                    key: 'eval_test',
                    modifier: (value) => {
                        let type = '';
                        if (value) {
                            if (value.type == 'E') {
                                type = 'Evaluación';
                            } else {
                                type = 'Testificación';
                            }
                        } else {
                            type = 'Acreditación';
                        }
                        return type;
                    }
                },
                {
                    title: 'Convenio',
                    type: 'custom-html',
                    key: 'is_agreement',
                    modifier: (value) => {
                        let type = 'NO';
                        if (value) {
                            type = 'SI ';
                        }
                        return type;
                    }
                },
                {
                    title: 'Envío facturas',
                    type: 'custom-html',
                    key: 'invoice_send',
                    modifier: (value) => {
                        if (value == 1) {
                            return `<span class="badge badge-sm badge-pill badge-success">Enviada</span>`;
                        } else {
                            return `<span class="badge badge-sm badge-pill badge-danger">Pendiente</span>`;
                        }

                    }
                },
                {
                    title: 'Agrupado',
                    type: 'custom-html',
                    key: 'eval_test',
                    modifier: (item) => {
                        if (item) {
                            if (item.key_combo) {
                                return `<span class="badge badge-sm badge-pill badge-primary">Por ${item.key_combo}</span>`;
                            } else {
                                return 'N/A';
                            }
                        } else {
                            return 'N/A';
                        }
                    }
                },

            ],
            actionObj: {
                title: 'Acciones',
                type: 'action',
            }
        }
    },
}